import script from "./delivered-returned-rts.vue?vue&type=script&setup=true&lang=js"
export * from "./delivered-returned-rts.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__